var map = {
	"./affix/style/index.tsx": 1037,
	"./alert/style/index.tsx": 1039,
	"./anchor/style/index.tsx": 1041,
	"./auto-complete/style/index.tsx": 1043,
	"./avatar/style/index.tsx": 1048,
	"./back-top/style/index.tsx": 1050,
	"./badge/style/index.tsx": 1052,
	"./breadcrumb/style/index.tsx": 1054,
	"./button/style/index.tsx": 125,
	"./calendar/style/index.tsx": 1056,
	"./card/style/index.tsx": 1059,
	"./carousel/style/index.tsx": 1062,
	"./cascader/style/index.tsx": 1064,
	"./checkbox/style/index.tsx": 208,
	"./col/style/index.tsx": 1067,
	"./collapse/style/index.tsx": 1068,
	"./date-picker/style/index.tsx": 1070,
	"./divider/style/index.tsx": 1074,
	"./drawer/style/index.tsx": 1076,
	"./dropdown/style/index.tsx": 962,
	"./form/style/index.tsx": 1079,
	"./grid/style/index.tsx": 395,
	"./icon/style/index.tsx": 1081,
	"./input-number/style/index.tsx": 1082,
	"./input/style/index.tsx": 124,
	"./layout/style/index.tsx": 1084,
	"./list/style/index.tsx": 1086,
	"./locale-provider/style/index.tsx": 1090,
	"./mention/style/index.tsx": 1092,
	"./menu/style/index.tsx": 1094,
	"./message/style/index.tsx": 1097,
	"./modal/style/index.tsx": 1099,
	"./notification/style/index.tsx": 1101,
	"./pagination/style/index.tsx": 397,
	"./popconfirm/style/index.tsx": 1103,
	"./popover/style/index.tsx": 963,
	"./progress/style/index.tsx": 964,
	"./radio/style/index.tsx": 393,
	"./rate/style/index.tsx": 1106,
	"./row/style/index.tsx": 1108,
	"./select/style/index.tsx": 207,
	"./slider/style/index.tsx": 1109,
	"./spin/style/index.tsx": 396,
	"./steps/style/index.tsx": 1111,
	"./switch/style/index.tsx": 1113,
	"./table/style/index.tsx": 1115,
	"./tabs/style/index.tsx": 959,
	"./tag/style/index.tsx": 961,
	"./time-picker/style/index.tsx": 960,
	"./timeline/style/index.tsx": 1117,
	"./tooltip/style/index.tsx": 391,
	"./transfer/style/index.tsx": 1119,
	"./tree-select/style/index.tsx": 1121,
	"./tree/style/index.tsx": 1123,
	"./upload/style/index.tsx": 1125,
	"./version/style/index.tsx": 1127
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1036;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/[^_][\w-]+\/style\/index\.tsx?$
// module id = 1036
// module chunks = 1